// Libraries
import React from 'react';
import { useTranslation } from 'react-i18next';

// Enums
import { BAR_VERTICAL, BAR_HORIZONTAL, PIE } from 'common/enums/chartTypes';
import { EngagementReportQuestionType } from 'engagementReport/enums/propTypes';

// Components
import OrderedVerticalBarChart from 'engagementReport/components/ordered/OrderedVerticalBarChart';
import OrderedHorizontalBarChart from 'engagementReport/components/ordered/OrderedHorizontalBarChart';
import OrderedPieCharts from 'engagementReport/components/ordered/OrderedPieCharts';

const renderChart = ({ chartType, data }) => {
  switch (chartType) {
    case BAR_HORIZONTAL:
      return <OrderedHorizontalBarChart data={data} />;
    case PIE:
      return <OrderedPieCharts data={data} />;
    case BAR_VERTICAL:
    default:
      return <OrderedVerticalBarChart data={data} />;
  }
};

const OrderedReport = ({ question }) => {
  const { t } = useTranslation();
  const isEmpty = question.data.values.every((value) => value.count === 0);

  return (
    <div className="ordered-report">
      {isEmpty && (
        <div className="basic-report__subtitle">{t('engagement_report.no_responses')}</div>
      )}
      {!isEmpty && renderChart(question)}
    </div>
  );
};

OrderedReport.propTypes = {
  question: EngagementReportQuestionType.isRequired,
};

export default OrderedReport;
